import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import CheckboxWithLabel from './CheckboxWithLabel';
import { StCheckBoxWrapper } from './CheckboxWithLabel.styles';
import { FormLabel } from '@mui/material';

const CheckboxWithLabelContainer = (props: any): JSX.Element => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
      }}
    >
      <FormLabel sx={{ paddingBottom: '10px' }}>
        <Text field={props?.label} />
      </FormLabel>
      <Grid container direction="column" gap="8px">
        {props?.options.map((item: any, itemIndex: number) => {
          return (
            <Grid item xs={12} key={itemIndex}>
              <StCheckBoxWrapper>
                <CheckboxWithLabel
                  index={itemIndex}
                  keyIndex={item?.fields?.keyIndex?.value}
                  type={props?.type}
                  label={item.fields?.label ?? item.fields?.name}
                  handleChange={props?.handleChange}
                  name={item.fields?.value ?? item.fields?.name}
                  id={item?.fields?.value?.value ?? item.fields?.name?.value}
                  checked={
                    props?.storedAnswers.find((ans: any) => ans.index === itemIndex) !== undefined
                      ? true
                      : false
                  }
                />
              </StCheckBoxWrapper>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default CheckboxWithLabelContainer;
